import { useState, useRef, useCallback } from 'react'
import analytics from 'global/AnalyticsData'

export const useStepNavigation = brk => {
  const [currentPosition, setCurrentPosition] = useState(0)
  // Ref allows handleIntersect to read current stepId without stale closure issues
  const currentStepIdRef = useRef('landing')

  const scrollToStep = useCallback((position, stepId) => {
    try {
      const el = document.querySelector(`.step-scroll-position-${position}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        window.parent.postMessage(
          { type: 'SCROLL_TO', value: el.getBoundingClientRect().top },
          '*',
        )
      }
    } catch (e) {
      console.log(`problem in scrollToStep(${position}): ${e}`)
    }
  }, [])

  const updateCurrentStep = useCallback((position, stepId) => {
    currentStepIdRef.current = stepId
    setCurrentPosition(position)
  }, [])

  const handleSideNavItemClick = useCallback(
    ({ stepId, position }) => {
      console.log('position to scroll to:', position, stepId)
      analytics.breakEvent('side_nav_click', brk)
      scrollToStep(position, stepId)
    },
    [brk, scrollToStep],
  )

  return {
    currentPosition,
    currentStepIdRef,
    scrollToStep,
    updateCurrentStep,
    handleSideNavItemClick,
  }
}
